import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { fetchSkillDevelopment } from "./SkillDevelopmentAPI";
import { fetchInterviewPreparation } from "./InterviewPreparationAPI";

export const fetchInterviewPreparationAsync = createAsyncThunk(
    "interviewPreparation/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchInterviewPreparation();
            return response;
        } catch (error) {
            return rejectWithValue(error.message || "Something went wrong");
        }
    }
);

const interviewPreparationSlice = createSlice({
    name: "interviewPreparation",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchInterviewPreparationAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInterviewPreparationAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchInterviewPreparationAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const selectInterviewPreparation = (state) => state.interviewPreparation.data;

export default interviewPreparationSlice.reducer;